export { default } from "./HeadsetControlDock";
export type { HeadsetControlDockProps } from "./types";
